import { render } from "./Main.vue?vue&type=template&id=8fd8f960&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=8fd8f960&lang=less&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=8fd8f960&lang=less"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd8f960"]])